import { redirect } from 'react-router-dom';
import { ADMIN_ROLE, SUPERADMIN_ROLE, api, hasRole } from './api';
import type { Principal } from './api';

/** Кеш на все завантаження застосунку; змінити його можуть лише вхід і вихід. */
let cached: Principal | null | undefined;

export async function currentPrincipal(): Promise<Principal | null> {
  if (cached === undefined) {
    cached = await api.me();
  }
  return cached;
}

export function clearPrincipalCache(): void {
  cached = undefined;
}

/** Без сесії перекидає на вхід, зберігаючи бажану адресу в `?from=`. */
export async function requireAuth(request: Request): Promise<Principal> {
  const principal = await currentPrincipal();
  if (!principal) {
    const from = new URL(request.url).pathname;
    // Для кореня `from` не додаємо — це шум в адресі.
    throw redirect(from === '/' ? '/login' : `/login?from=${encodeURIComponent(from)}`);
  }
  return principal;
}

/** Це UX, а не захист: роль по-справжньому перевіряє бекенд. */
export async function requireAdmin(request: Request): Promise<Principal> {
  const principal = await requireAuth(request);
  if (!hasRole(principal, ADMIN_ROLE)) {
    throw redirect('/');
  }
  return principal;
}

/** Видача доступів — вужча влада за роботу з панеллю, тому окремо від ADMIN. */
export async function requireSuperadmin(request: Request): Promise<Principal> {
  const principal = await requireAuth(request);
  if (!hasRole(principal, SUPERADMIN_ROLE)) {
    throw redirect('/');
  }
  return principal;
}

/** Не `useRevalidator()`: глобальна ревалідація блимала б усім екраном через рядок у боковині. */
const conversationsListeners = new Set<() => void>();

/** Повертає функцію відписки. */
export function onConversationsChanged(listener: () => void): () => void {
  conversationsListeners.add(listener);
  return () => {
    conversationsListeners.delete(listener);
  };
}

export function notifyConversationsChanged(): void {
  for (const listener of conversationsListeners) {
    listener();
  }
}
